import React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import { DATATEST } from "constants/integration";

const LargeTile = (props: SvgIconProps) => (
    <SvgIcon {...props} data-test={DATATEST.PROFILE.GRID_VIEW_TYPES.LARGE_TILE}>
        <path d="M 21.82 2 L 2.182 2 C 0.873 2 0 2.4 0 3 L 0 21 C 0 21.6 0.873 22 2.182 22 L 21.82 22 C 23.129 22 24.002 21.6 24.002 21 L 24.002 3 C 24.002 2.4 23.129 2 21.82 2 Z" />
    </SvgIcon>
);

export default LargeTile;
